import { Share2 } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

/**
 * Lesson share button.
 * - Uses the Web Share API when available (mobile)
 * - Falls back to clipboard copy with a toast
 * - Builds a deep link via hash: `<origin>/#/lesson/<lessonId>`
 */
export default function ShareButton({ lessonId, title, summary }) {
  const { toast } = useToast();

  const onShare = async () => {
    const url = `${window.location.origin}${window.location.pathname}#/lesson/${lessonId}`;
    const shareData = {
      title: `${title} · The Hormone-Gut Axis`,
      text: summary,
      url,
    };

    try {
      if (
        typeof navigator !== "undefined" &&
        typeof navigator.share === "function"
      ) {
        await navigator.share(shareData);
        return;
      }
    } catch (e) {
      // User cancelled or share failed — fall through to copy
      if (e && e.name === "AbortError") return;
    }

    try {
      await navigator.clipboard.writeText(url);
      toast({
        title: "Link copied",
        description: "Share link copied to clipboard.",
      });
    } catch {
      toast({
        title: "Couldn't copy link",
        description: url,
      });
    }
  };

  return (
    <button
      type="button"
      onClick={onShare}
      className="btn btn-ghost touch"
      data-testid="lesson-share-btn"
      aria-label={`Share lesson: ${title}`}
      style={{ padding: "0 16px", minHeight: 44, fontSize: 14 }}
    >
      <Share2 size={16} strokeWidth={1.75} aria-hidden="true" />
      Share
    </button>
  );
}
